import {
    Link
    , useNavigate
} from 'react-router-dom';

import RealSplitLaunches from "./RealSplitLaunches";

const RealSplitNews = (props) => {
    console.debug('RealSplitNews(props)', props);

    console.debug('props.urlSlug = ', props.urlSlug);

    const navigate = useNavigate();

    return (
        <>

        <div
            style = {{ padding: '0px 0px 30px 10px' }}
            >
            <button
                //className = 'primary-inverse circular medium'
                className = 'theme-sensei'
                style = {{
                    marginLeft: '0'
                    , paddingRight: '18px'
                    //, paddingBottom: '4px'
                }}
                onClick = { () => navigate('/news') }
                >
                <img
                    //src='/images/icons/left-arrow-icon.svg'
                    src='/images/icons/arrow-left.svg'
                    style = {{
                        paddingRight: '10px'
                        //, filter: 'invert(11%) sepia(100%) saturate(6205%) hue-rotate(244deg) brightness(83%) contrast(145%)'
                    }}
                    />
                    <div
                        style = {{
                            display: 'inline-block'
                            , lineHeight: '16px'
                            , verticalAlign: 'middle'
                            //, paddingTop: '2px'
                        }}>
                        Back to News
                    </div>
            </button>
        </div>

        {
            props.urlSlug == 'RealSplitLaunches'
            && <RealSplitLaunches />

        }
        
        </>
    );
};
  
export default RealSplitNews;